module.exports = __webpack_public_path__ + "img/p2-desc.9cdeb6d9.jpg";